var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg019AmmhHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2_copy_2",
    "data-name": "Group 2 copy 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1509,
    height: 333.5,
    viewBox: "0 0 3018 667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #858585;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #424242;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2_copy",
    "data-name": "Polygon 2 copy",
    className: "cls-1",
    d: "M334.259,0.1L667.607,666.79H0.911Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    className: "cls-2",
    d: "M334.255,0.1L500.928,333.442H167.58Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    className: "cls-1",
    d: "M1117.6,333.444L784.253,666.792V0.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy",
    "data-name": "Polygon 1 copy",
    className: "cls-1",
    d: "M1117.59,333.444l333.34,333.348V0.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_6",
    "data-name": "Rectangle 1 copy 6",
    className: "cls-1",
    d: "M784.259,333.444H1450.93V666.778H784.259V333.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_7",
    "data-name": "Rectangle 1 copy 7",
    className: "cls-2",
    d: "M1117.59,333.444h333.34V666.778H1117.59V333.444Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "M_copy",
    "data-name": "M copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy_2",
    "data-name": "Polygon 1 copy 2",
    className: "cls-1",
    d: "M1901.27,333.555L1567.92,666.9V0.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    className: "cls-2",
    d: "M1901,333H1568L1567.92,0.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy-2",
    "data-name": "Polygon 1 copy",
    className: "cls-1",
    d: "M1901.25,333.555L2234.6,666.9V0.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_6-2",
    "data-name": "Rectangle 1 copy 6",
    className: "cls-1",
    d: "M1567.93,333.555h666.66V666.889H1567.93V333.555Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_17",
    "data-name": "Rectangle 1 copy 17",
    className: "cls-1",
    d: "M2351,0h292.99V667.014H2351V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_18",
    "data-name": "Rectangle 1 copy 18",
    className: "cls-1",
    d: "M2729,0h288.99V667.014H2729V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_9",
    "data-name": "Rectangle 1 copy 9",
    className: "cls-2",
    d: "M2729,0h288.99V500H2729V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_10",
    "data-name": "Rectangle 1 copy 10",
    className: "cls-2",
    d: "M2644.01,501.007h87V334h-87V501.007Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg019AmmhHorizontal);
export default __webpack_public_path__ + "static/media/019_AMMH_horizontal.f6612efa1865f3f924bb03db5c1fd428.svg";
export { ForwardRef as ReactComponent };